import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  billedFilter,
  onBoardedFilter,
  lmtdCheck,
  getJCJPIDs,
} from "../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
import { distCsvFilter } from "../../../../utils/common/csvMappings/deviceDistributionCsv";
import DeviceSalesDistributionTabsView from "../../../../views/deviceSales/distribution/deviceSalesDistributionTabsView";
import {
  fetchShowAlert,
  hideAlert,
} from "../../../../redux/actions/homeAction";
import { useRef } from "react";

const DeviceSalesDistributionTabs = (props) => {
  const dispatch = useDispatch();
  const { distributionObj, csvLoading } = useSelector(
    (state) => state.homeReducer
  );

  const PreviousValue = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };
  
  let {
    url,
    isCsvActive,
    csvEndPointUrl,
    section,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerFetchDistributionTable,
    triggerRDSAPI,
  } = props;

  const pV = PreviousValue(filterValue);

  let { level, jioPointId, partnerRT } = getJCJPIDs(filterValue);
  const $ = window.jQuery;
  const data = {
    id: filterValue.selectedRole
      ? filterValue.selectedRole.split(" - ")[2]
      : filterValue.orgId,
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: section,
    moduleName: props.moduleName,
    level: level,
    jioPointId: jioPointId,
    jprTypeName:
      filterValue.selectedCategory && filterValue.selectedCategory !== "ALL"
        ? filterValue.selectedCategory
        : "",
  };

  useEffect(() => {
    const controller = new AbortController();

    function fetchData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: data,
        extraData: url,
      };

      return dispatch(triggerFetchDistributionTable(obj, controller.signal));
    }
    // console.log("here", filterValue.selectedCategory,distributionObj && distributionObj.distributionTableData[url] === undefined, pV?.selectedCategory !== filterValue?.selectedCategory)
    if (
      (distributionObj &&
      distributionObj.distributionTableData[url] === undefined) || (pV &&
        pV.selectedCategory !== filterValue &&
        filterValue.selectedCategory)
    ) {
      fetchData();
    }
    $(function () {
      $(".carousel .carousel-inner").swipe({
        //Generic swipe handler for all directions
        swipe: function (
          event,
          direction,
          distance,
          duration,
          fingerCount,
          fingerData
        ) {
          $(this).text("You swiped " + direction);
        },
      });
      //Set some options later
      $(".carousel .carousel-inner").swipe({ fingers: 2 });
    });

    // Cleanup function to cancel the request if the component unmounts
    return () => {
      controller.abort(); // Cancels the request when the component unmounts
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerFetchDistributionTable,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    filterValue.selectedCategory
  ]);

  function fetchCsvData(tab) {
    // if(tab === 'Billed'){
    //     setDownloadBilledCsv(true);
    // }
    // else if (tab === 'On boarded'){
    //     setDownloadBoardedCsv(true);
    // }
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: {
        id: filterValue.orgId
          ? filterValue.orgId
          : filterValue.selectedRole.split(" - ")[2],
        partnerRoleType: partnerRT,
        fromDate: headerSelectedDateFrom,
        toDate: headerSelectedDateTo,
        section: section,
        moduleName: props.moduleName,
        dist: tab === "Billed" ? "billed" : "onboard",
        level: level,
        jioPointId: jioPointId,
        jprTypeName:
          filterValue.selectedCategory && filterValue.selectedCategory !== "ALL"
            ? filterValue.selectedCategory
            : "",
      },
      extraData: csvEndPointUrl,
      tab: tab,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      title: "Data",
      useTextFile: false,
      filename: `${props.moduleName}-${section}`,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerRDSAPI(obj, (response, params) => {
        if (response?.content?.length) {
          // console.log(params.dist)
          let csvData;
          csvData = distCsvFilter(
            props.moduleName,
            props.tileName,
            partnerRT,
            params.dist,
            response.content
          );
          csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlert());
          setTimeout(() => {
            dispatch(hideAlert());
          }, 5000);
        }
      })
    );
  }

  return (
    <DeviceSalesDistributionTabsView
      distributionObj={distributionObj}
      csvLoading={csvLoading}
      url={url}
      headerSelectedDateFrom={headerSelectedDateFrom}
      headerSelectedDateTo={headerSelectedDateTo}
      csvEndPointUrl={csvEndPointUrl}
      isCsvActive={isCsvActive}
      fetchCsvData={fetchCsvData}
      dashboardName={props.moduleName}
    />
  );
};

DeviceSalesDistributionTabs.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerSimActivationAPI: PropTypes.func,
  triggerSimActivationCsvAPI: PropTypes.func,
};

export default DeviceSalesDistributionTabs;
